import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./index.scss";
import uploadIcon from "../../../../Assets/icons/uploadicon.svg";
import searchIcon from "../../../../Assets/icons/searchicon.svg";

import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import Switch from "react-switch";
import { ToastContainer } from "react-toastify";
import axiosInstance from "../../../services/api/API";

const AddIssueDynemicForm = ({
  formConfig,
  formData,
  setFormData,
  validationErrors = {},
  setValidationErrors = {},
  showParentDesignation,
  setShowParentDesignation = () => {},
  images,
  buttonOnclick,
  setIsMultipleCities,
  setCities,
  cities,
  isComplaint,
  apiCall
}) => {
  //console.log("showParentDesignation",showParentDesignation);
  const [fileNames, setFileNames] = useState({});

  const [pincode, setPincode] = useState("");

  const [isInitial, setIsInitial] = useState(true);

  // states for date picker
  const [selectedDate, setSelectedDate] = useState(null);
  const today = new Date();

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const token = localStorage.getItem("authToken");
  const user_type = localStorage.getItem("UserType");
  const datePickerRefs = useRef({});
  const allowedKeys = {
    numbersOnly: /^[0-9]$/,
    alphanumeric: /^[a-zA-Z0-9]$/,
    decimalnumber: /^[0-9.]$/,
    controlKeys: [ 'Backspace','Delete', 'ArrowLeft', 'ArrowRight'],
  };
  const inputKeyPatterns = {
    rtoregiamountcorp: allowedKeys.numbersOnly,
    rtoregiamountindi: allowedKeys.numbersOnly,
    contact_no: allowedKeys.numbersOnly,
    mobile: allowedKeys.numbersOnly,
    altmobile: allowedKeys.numbersOnly,
    contactno: allowedKeys.numbersOnly,
    pincode: allowedKeys.numbersOnly,
    discount: allowedKeys.numbersOnly,
    accountno: allowedKeys.alphanumeric,
    chassisno: allowedKeys.alphanumeric,
    engineno: allowedKeys.alphanumeric,
    pan_no:allowedKeys.alphanumeric,
    hsnname: allowedKeys.numbersOnly,
    hsnCode: allowedKeys.numbersOnly,
    hsncode: allowedKeys.numbersOnly,
    cubic_capacity: allowedKeys.decimalnumber,
    extamount:allowedKeys.decimalnumber,
    JobEstimateAmount:allowedKeys.decimalnumber,
  };
  
  useEffect(() => {
      console.log("pincodeformdata",formData?.pincode);
      
    if (pincode.length === 6 || formData?.pincode?.length === 6) {
      const fetchPincodeData = async () => {
        try {
          const response = await axiosInstance.post(
            "/pincodestatecity/getbypincode",
            {
              pincode: pincode,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          if (response.status === 200) {
            const data = response?.data?.data[0];
            
            // Check for empty data
            if (!data) {
              // Set validation error for pincode
              setValidationErrors((prevErrors) => ({
                ...prevErrors,
                pincode: "Invalid Pincode*",
              }));
              setFormData((prevData) => ({
                ...prevData,
                city:"",
                state:"",
                country:""
               
              }));
            } else {
              // If valid, update formData and clear any previous pincode validation error
              setFormData((prevData) => ({
                ...prevData,
                city: data?.city_name,
                city_id: data?.city_id,
                state: data?.state_name,
                state_id: data?.state_id,
                country: data?.country_name,
                country_id: data?.country_id,
              }));
  
              setValidationErrors((prevErrors) => ({
                ...prevErrors,
                pincode: "", // Clear pincode error if valid
              }));
            }
          } else {
            throw new Error("Failed to fetch data");
          }
        } catch (error) {
          console.error("Error fetching data:", error);
          setValidationErrors((prevErrors) => ({
            ...prevErrors,
            pincode: "Failed to fetch data", // Set error message if request fails
          }));
        }
      };
  
      fetchPincodeData();
    }
  }, [formData?.pincode]);

  const handleKeyPress = (name, e, type, maxLength) => {
    const { key, target } = e;
    if (allowedKeys.controlKeys.includes(key)) {
      return; // Allow these keys
    }

    if (target.value.length >= maxLength) {
      e.preventDefault(); 
      return;
    }
    if (name === 'chassisno' || name === 'engineno' || name === 'registrationno' || name === 'panno') {
      const isAlphabet = /^[a-zA-Z]$/.test(key);
  
      if (isAlphabet) {
        e.preventDefault(); // Prevent default input
        target.value += key.toUpperCase(); // Append the uppercase letter
       return;
      }
    }
  
    // Handle pattern-based validation (e.g., numbers, alphanumeric)
    if (type === "text" && inputKeyPatterns[name]) {
      const allowedPattern = inputKeyPatterns[name];
  
      if (!allowedPattern.test(key)) {
        e.preventDefault(); // Prevent disallowed characters
      }
    }
  };
  
  
  
  
  // const [validationErrors, setValidationErrors] = useState({});

  //   useEffect(() => {
  //     if (pincode.length === 6) {
  //       const fetchPincodeData = async () => {
  //         try {
  //           const response = await axiosInstance.post(
  //             "/pincodestatecity/getbypincode",
  //             {

  //               pincode: pincode,
  //             },
  //             {
  //               headers: {
  //                 "Content-Type": "application/json",
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );

  //           if (response.status === 200) {
  //             const data = response?.data?.data[0];
  //             if (!data) {
  //             }
  //             setFormData((prevData) => ({
  //               ...prevData,
  //               city: data?.city_name,
  //               city_id: data?.city_id,
  //               state: data?.state_name,
  //               state_id: data?.state_id,
  //               country: data?.country_name,
  //               country_id: data?.country_id,
  //             }));
  //           } else {
  //             throw new Error("Failed to fetch data");
  //           }
  //         } catch (error) {
  //           console.error("Error fetching data:", error);
  //         }
  //       };

  //       fetchPincodeData();
  //     }
  //     console.log(formData, "PINcode");
  //   }, [pincode, setFormData]);

  // useEffect(() => {
  //   if (pincode.length === 6) {
  //     const fetchPincodeData = async () => {
  //       try {
  //         const response = await axiosInstance.post(
  //           "/pincodestatecity/getbypincode",
  //           { pincode: pincode },
  //           {
  //             headers: {
  //               "Content-Type": "application/json",
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         if (response.status === 200) {
  //           const data = response?.data?.data;
  //           if (data && data.length > 0) {
  //             // Check if there are multiple cities
  //             if (data.length === 1) {
  //               // If only one city, set the form data directly
  //               const cityData = data[0];
  //               setFormData((prevData) => ({
  //                 ...prevData,
  //                 city: cityData.city_name,
  //                 city_id: cityData.city_id,
  //                 state: cityData.state_name,
  //                 state_id: cityData.state_id,
  //                 country: cityData.country_name,
  //                 country_id: cityData.country_id,
  //               }));
  //               // setIsMultipleCities(false);
  //             } else {
  //               // If multiple cities, set the cities state
  //               setCities(data);
  //               setIsMultipleCities(true);
  //               // Clear previous city selection if any
  //               setFormData((prevData) => ({
  //                 ...prevData,
  //                 city: data[0].city_name ,
  //                 city_id: data[0].city_id,
  //                 state: data[0].state_name,
  //                 state_id: data[0].state_id,
  //                 country: data[0].country_name,
  //                 country_id: data[0].country_id,
  //               }));
  //             }
  //           }
  //         } else {
  //           throw new Error("Failed to fetch data");
  //         }
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       }
  //     };
  //     fetchPincodeData();
  //   }
  //   console.log(formData, "PINcode");
  // }, [pincode, setFormData]);

  useEffect(() => {
    console.log("fomrdatapincode",formData?.pincode);
    
    if (formData?.pincode && formData?.pincode.length === 6) {
      setPincode(formData?.pincode);
    }
  }, [formData?.pincode]);
 
  useEffect(() => {
    if (images && images.length > 0) {
      const initialFileNames = {};
      const initialFormData = {};
      images.forEach((image) => {
        initialFileNames[image?.document_type] = image?.document;
        initialFormData[image?.document_type] = image?.image_path;
      });
      setFileNames(initialFileNames);
      setFormData((prevData) => ({
        ...prevData,
        ...initialFormData,
      }));
    }
  }, [images, setFormData]);

  const handleChange = (name, value, type) => {
    console.log(name, value, "pincodevalue");
    
    if (type === "checkbox" || type === "toggle") {
      if (name == "extendedToggle" && value == true) {
        console.log("name>>", name, value);
        setShowParentDesignation(true);
      } else {
        setShowParentDesignation(false);
      }
      setFormData({ ...formData, [name]: value });
      console.log("formdata???", formData);
    } else if (type === "file") {
      setFormData({ ...formData, [name]: value });
      setFileNames({ ...fileNames, [name]: value.name });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    if (name === "pincode") {
      setPincode(value);
    }
    validateField(name, value);
  };

  const validateField = (name, value) => {
    console.log("panvalue",value);
    
    const fieldConfig = formConfig.find((field) => field.name === name);
    if (fieldConfig && fieldConfig?.validation) {
      const { required, minLength, maxLength, pattern, message } =
        fieldConfig.validation;
      let error = "";

      if (required && (value === undefined || value === null || value === "")) {
        console.log("value", value);
        error = "This field is required*";
      } else if (minLength && value.length < minLength) {
        error = `Minimum length ${minLength} characters`;
      } else if (maxLength && value.length > maxLength) {
        error = `Maximum length ${maxLength} characters`;
      } else if (pattern && !pattern.test(value)) {
        error = `${message}`;
      }

      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [name]: error,
      }));
    }
  };

  const handleMultiSelectChange = (name, selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    setFormData({ ...formData, [name]: selectedValues });
    validateField(name, selectedValues);
  };

  const handleDropdownChange = (name, selectedOption) => {
    if (name === "productName") {
      setFormData({
        ...formData,
        [name]: selectedOption.value,
        subproductName: null,
        makeName: null,
      });
    } else if (name === "city") {
      const selectedCity = cities.find(
        (city) => city.city_id === selectedOption.value
      );
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedOption.label,
        city_id: selectedOption.value,
        state: selectedCity.state_name,
        state_id: selectedCity.state_id,
        country: selectedCity.country_name,
        country_id: selectedCity.country_id,
      }));
    } else {
      setFormData({ ...formData, [name]: selectedOption.value });
    }
    validateField(name, selectedOption ? selectedOption.value : null);
  };

  // const handleDropdownChange = (name, selectedOption) => {
  //   if (name === "productName") {
  //     setFormData({
  //       ...formData,
  //       productName: selectedOption ? selectedOption.value : null,
  //       subproductName: null, // Clear subproductName
  //       makeName: null        // Clear makeName
  //     });
  //   } else if (name === "subproductName") {
  //     setFormData({
  //       ...formData,
  //       subproductName: selectedOption ? selectedOption.value : null,
  //       makeName: null // Clear makeName
  //     });
  //   } else {
  //     setFormData({
  //       ...formData,
  //       [name]: selectedOption ? selectedOption.value : null
  //     });
  //   }
  //   validateField(name, selectedOption ? selectedOption.value : null);
  // };

  const handleRichTextChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: "#ccc",
      boxShadow: "none",
      borderRadius: "10px",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: "flex",
      alignItems: "center",
      height: "50px",
      width: "500px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "5px",
      borderColor: "#ccc",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#7BD755"
        : state.isFocused
        ? "#fff"
        : null,
      // color: state.isSelected || state.isFocused ? "white" : "black",
      "&:hover": {
        backgroundColor: "#f2fcf0",
        color: "#000",
      },
    }),
  };

  const handleFileDrop = (e, name) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setFormData({ ...formData, [name]: file });
    setFileNames({ ...fileNames, [name]: file.name });
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };



  const renderField = (field) => {
    const additionalClass = field.gridClass ? ` ${field.gridClass}` : "";
    switch (field.type) {
      case "text":
      case "email":
      case "number":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <input
              type={field?.type}
              name={field?.name}
              value={formData[field?.name] || ""}
              placeholder={field?.placeholder || ""}
              disabled={field?.disabled}
              // minLength={2}
              maxLength={field?.validation && field?.validation?.maxLength}
              onChange={(e) =>
                handleChange(field.name, e.target.value, field.type)
              }
              onKeyDown={(e)=>handleKeyPress(field.name, e, field.type,field?.validation?.maxLength)}
              className={`form-control ${
                validationErrors[field?.name] && "is-invalid"
              }`}
            />

             {isComplaint && (
                <div
                  style={{
                    marginLeft: 10,
                    borderRadius: 10,
                    width: 50,
                    cursor: "pointer",
                  }}
                  onClick={apiCall}
                >
                  <img src={searchIcon} alt="Job Card Icon" />
                </div>
              )}
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );
      case "textarea":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <textarea
              name={field.name}
              value={formData[field.name] || ""}
              placeholder={field.placeholder || ""}
              disabled={field.disabled}
              maxLength={field?.validation?.maxLength}
              rows={field.rows || 4}
              onChange={(e) =>
                handleChange(field.name, e.target.value, "textarea")
              }
              className={`form-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
            />
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "radio":
        return (
          <div  key={field?.name} className={`${additionalClass}`}>
            <label>{field?.label}</label>
            <div>
              <div style={{display:"flex", flexDirection:"column"}} >
                <div className="radio-classname" >    
              {field?.options.map((option) => (
                <div key={option.value} className="form-check">
                  <input
                    type="radio"
                    name={field?.name}
                    value={option?.value}
                    checked={formData[field?.name] === option.value}
                    onChange={(e) =>
                      handleChange(field.name, e.target.value, "radio")
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label">{option.label}</label>
                </div>
              ))}
                </div>
                {/* <div>
              {field?.isComplaint && (
                <div
                  style={{
                    marginLeft: 10,
                    borderRadius: 10,
                    width: 600,
                    cursor: "pointer",
                  }}
                  onClick={apiCall}
                >
            <div>
                  <img src={searchIcon} alt="Job Card Icon" />
            </div>
            
                </div>
              )}
                </div> */}
              </div>
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "multiselectcheckbox":
        return (
          <div
            key={field.name}
            className={`form-group${additionalClass} mt-3 mb-3`}
          >
            <label className="mt-3 mb-3 filelabel">
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="checkbox-container">
              {field.options.map((option) => (
                <div key={option.value} className="checkbox-item">
                  <input
                    type="checkbox"
                    name={option?.value}
                    checked={formData[option?.value] || false}
                    onChange={(e) =>
                      handleChange(option?.value, e.target.checked, "checkbox")
                    }
                    className="form-check-input"
                  />
                  <label className="form-check-label">{option?.label}</label>
                  {option.value === "totalUsers" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="number"
                      name="totalUsersCount"
                      value={formData.totalUsersCount || ""}
                      onChange={(e) =>
                        handleChange(
                          "totalUsersCount",
                          e.target.value,
                          "number"
                        )
                      }
                      className="form-control"
                    />
                  )}
                  {option.value === "maxhierarchy" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="number"
                      name="maxhierarchy"
                      value={formData.maxhierarchy || ""}
                      onChange={(e) =>
                        handleChange("maxhierarchy", e.target.value, "number")
                      }
                      className="form-control"
                    />
                  )}
                  {option.value === "userPrefix" && (
                    <input
                      style={{ width: "65px", height: "30px" }}
                      type="text"
                      name="userPrefix"
                      value={formData?.userPrefix || ""}
                      onChange={(e) =>
                        handleChange("userPrefix", e.target.value, "text")
                      }
                      className="form-control"
                    />
                  )}
                </div>
              ))}
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "multiselectdropdown":
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <Select
              isMulti
              name={field?.name}
              options={field?.options}
              styles={customStyles}
              //value={formData[field.name] || []}
              value={field?.options.filter((option) =>
                formData[field.name]?.includes(option.value)
              )}
              onChange={(selectedOptions) =>
                handleMultiSelectChange(field?.name, selectedOptions)
              }
              className={`select-control ${
                validationErrors[field.name] && "is-invalid"
              }`}
            />
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "dropdown":
        return (
          <div key={field.name} className="mt-2 mb-2">
            <label>
              {field?.label}
              {field?.required && <span className="required-asterisk">*</span>}
            </label>

            <Select
              key={field.name}
              name={field.name}
              options={field?.options}
              styles={customStyles}
              defaultValue={formData[field.name] || field.defaultValue}
              value={
                field.options.find(
                  (option) => option?.value === formData[field?.name]
                ) || null
              }
              onChange={(selectedOption) =>
                handleDropdownChange(field?.name, selectedOption)
              }
              menuPlacement={field?.dropdownOptionsListPosition || "auto"}
            />
            {validationErrors[field.name] && (
              <div className="customerror">{validationErrors[field.name]}</div>
            )}
          </div>
        );
      case "richeditor":
        return (
          <div key={field?.name} className={`form-group${additionalClass}`}>
            <label>{field?.label}</label>
            <ReactQuill
              value={formData[field?.name] || ""}
              onChange={(value) => handleRichTextChange(field?.name, value)}
              className="rich-editor"
              modules={{
                toolbar: {
                  container: [
                    ["bold", "italic", "underline", "strike"],
                    [{ header: "1" }, { header: "2" }, { font: [] }],
                    [{ size: [] }],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link", "image", "video"],
                    ["clean"],
                  ],
                },
              }}
            />
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );

      case "uploadFile":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
            </label>
            <div className="customFileUploaddd">
              <div key={field.name} className={`form-group${additionalClass}`}>
                <div
                  className="file-drop-area pt-3"
                  onDrop={(e) => handleFileDrop(e, field.name)}
                  onDragOver={handleDragOver}
                >
                  {/* <input
                  type='file'
                  name={field.name}
                  onChange={(e) => handleChange(field.name, e.target.files[0], 'file')}
                  className='form-control-file'
                />
                <div className='file-message'>
                  {fileNames[field.name] || 'Drag and drop a file or click to upload'}
                </div> */}
                  <div className="">
                    <div className="custom-file-upload">
                      <input
                        type="file"
                        name={field.name}
                        id={field.name}
                        onChange={(e) =>
                          handleChange(field.name, e.target.files[0])
                        }
                        className="file-input"
                        style={{ display: "none" }}
                      />
                      <label htmlFor={field.name} className="custom-file-label">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {/* <GrUploadOption className='uploadIcon' size={20} /> */}
                          <img src={uploadIcon} />
                          {fileNames[field.name] || (
                            <div>
                              <p style={{ fontSize: "15px" }}>
                                Drag your files here or{" "}
                                <span style={{ color: "#7BD755" }}>Browse</span>
                              </p>
                              <p
                                style={{ fontSize: "14px", fontWeight: "300" }}
                              >
                                ((File Format - Xlsx, CSV))
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {validationErrors[field.name] && (
                  <div className="invalid-feedback">
                    {validationErrors[field.name]}
                  </div>
                )}
                {formData[field.name] ? (
                  <div style={{ marginTop: "10px" }}>
                    File Uploaded successfully
                  </div>
                ) : null}
                {/* {formData[field.name] && (
                <img
                  src={formData[field?.name]}
                  alt="uploaded"
                  style={{ width: '100px', height: '100px', objectFit: 'cover', marginTop: '10px' }}
                />
              )} */}
              </div>
            </div>
          </>
        );

      // case "file":
      //   return (
      //     <>
      //       <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
      //         {field.label}
      //       </label>
      //       <div key={field.name} className={`form-group${additionalClass}`}>
      //         <div
      //           className="file-drop-area"
      //           onDrop={(e) => handleFileDrop(e, field.name)}
      //           onDragOver={handleDragOver}
      //         >
      //           {/* <input
      //           type='file'
      //           name={field.name}
      //           onChange={(e) => handleChange(field.name, e.target.files[0], 'file')}
      //           className='form-control-file'
      //         />
      //         <div className='file-message'>
      //           {fileNames[field.name] || 'Drag and drop a file or click to upload'}
      //         </div> */}
      //           <div className="customFileUpload">
      //             <div className="custom-file-upload">
      //               <input
      //                 type="file"
      //                 name={field.name}
      //                 id={field.name}
      //                 onChange={(e) =>
      //                   handleChange(field.name, e.target.files[0])
      //                 }
      //                 className="file-input"
      //                 style={{ display: "none" }}
      //               />
      //               <label htmlFor={field.name} className="custom-file-label">
      //                 <div
      //                   style={{
      //                     display: "flex",
      //                     flexDirection: "column",
      //                     alignItems: "center",
      //                     justifyContent: "center",
      //                   }}
      //                 >
      //                   {/* <GrUploadOption className='uploadIcon' size={20} /> */}
      //                   <img src={uploadIcon} />
      //                   {fileNames[field.name] || (
      //                     <div>
      //                       <p style={{ fontSize: "15px" }}>
      //                         Drag your files here or{" "}
      //                         <span style={{ color: "#7BD755" }}>Browse</span>
      //                       </p>
      //                       <p style={{ fontSize: "14px", fontWeight: "300" }}>
      //                         (File Format - JPG, PNG)
      //                       </p>
      //                     </div>
      //                   )}
      //                 </div>
      //               </label>
      //             </div>
      //           </div>
      //         </div>
      //         {validationErrors[field.name] && (
      //           <div className="invalid-feedback">
      //             {validationErrors[field.name]}
      //           </div>
      //         )}
      //         {formData[field.name] && (
      //           <img
      //             src={formData[field?.name]}
      //             alt="uploaded"
      //             style={{
      //               width: "100px",
      //               height: "100px",
      //               objectFit: "cover",
      //               marginTop: "10px",
      //             }}
      //           />
      //         )}
      //       </div>
      //     </>
      //   );

      case "file":
        return (
          <>
            <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              {field.label}
            </label>
            <div key={field.name} className={`form-group${additionalClass}`}>
              <div
                className="file-drop-area"
                onDrop={(e) => handleFileDrop(e, field.name)}
                onDragOver={handleDragOver}
              >
                <div className="customFileUpload">
                  <div className="custom-file-upload">
                    <input
                      type="file"
                      name={field.name}
                      id={field.name}
                      onChange={(e) =>
                        handleChange(field.name, e.target.files[0])
                      }
                      className="file-input"
                      style={{ display: "none" }}
                    />
                    <label htmlFor={field.name} className="custom-file-label">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img src={uploadIcon} />
                        {fileNames[field.name] || (
                          <div>
                            <p style={{ fontSize: "15px" }}>
                              Drag your files here or{" "}
                              <span style={{ color: "#7BD755" }}>Browse</span>
                            </p>
                            <p style={{ fontSize: "14px", fontWeight: "300" }}>
                              (File Format - JPG, PNG)
                            </p>
                          </div>
                        )}
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              {validationErrors[field.name] && (
                <div className="invalid-feedback">
                  {validationErrors[field.name]}
                </div>
              )}
            
              
            {formData[field.name] ? (
              typeof formData[field.name] === "string" ? ( // Check if it's a URL
                <div style={{ marginTop: "10px" }}>
                  <a
                    href={formData[field.name]} // Use the URL for the existing image
                    download // This attribute makes it downloadable
                    style={{ textDecoration: "none", color: "#7BD755" }}
                    target="_blank"
                  >
                    <img
                      src={formData[field.name]} // Use the URL for the existing image
                      alt="uploaded"
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                        marginTop: "10px",
                      }}
                    />

                   
                  </a>
                </div>
              ) : (
                <a
                href={URL.createObjectURL(formData[field.name])} // Create a temporary URL
                download // This attribute makes it downloadable
                style={{ textDecoration: "none", color: "#7BD755" }}
                target="_blank"
              >
                <img
                  src={URL.createObjectURL(formData[field.name])} // Generate URL for the uploaded image
                  alt="uploaded"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    marginTop: "10px",
                  }}
                />
                </a>
              )
            ) : (
              <div style={{ marginTop: "10px" }}>
                <p style={{ fontSize: "15px", color: "#7BD755" }}>
                  {`No file uploaded`}
                </p>
              </div>
            )}
            </div>
          </>
        );

        case "agentfile":
          return (
            <>
              <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
                {field.label}
              </label>
              <div key={field.name} className={`form-group${additionalClass}`}>
                <div
                  className="file-drop-area"
                  onDrop={(e) => handleFileDrop(e, field.name)}
                  onDragOver={handleDragOver}
                >
                 
                  <div className="customFileUpload">
                    <div className="custom-file-upload">
                      <input
                        type="file"
                        name={field.name}
                        id={field.name}
                        onChange={(e) =>
                          handleChange(field.name, e.target.files[0])
                        }
                        className="file-input"
                        style={{ display: "none" }}
                      />
                      <label htmlFor={field.name} className="custom-file-label">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img src={uploadIcon} />
                          {fileNames[field.name] || (
                            <div>
                              <p style={{ fontSize: "15px" }}>
                                Drag your files here or{" "}
                                <span style={{ color: "#7BD755" }}>Browse</span>
                              </p>
                              <p style={{ fontSize: "14px", fontWeight: "300" }}>
                                (File Format - JPG, PNG)
                              </p>
                            </div>
                          )}
                        </div>
                      </label>
                    </div>
                  </div>
                </div>
                {validationErrors[field.name] && (
                  <div className="error-feedback">
                    {validationErrors[field.name]}
                  </div>
                )}
              
                {formData[field.name] ? (
                  <div style={{ marginTop: "10px" }}>
                    <p style={{ fontSize: "15px", color: "#7BD755" }}>
                   { formData[field.name].name}
                    </p>
                  </div>
                ) : null}
              </div>
            </>
          );

      // case "file":
      //   return (
      //     <>
      //       <label style={{ paddingBottom: "10px", paddingTop: "10px" }}>
      //         {field.label}
      //       </label>
      //       <div key={field.name} className={`form-group${additionalClass}`}>
      //         <div
      //           className="file-drop-area"
      //           onDrop={(e) => handleFileDrop(e, field.name)}
      //           onDragOver={handleDragOver}
      //         >
      //           <div className="custom-file-upload">
      //             <input
      //               type="file"
      //               name={field.name}
      //               id={field.name}
      //               onChange={(e) =>
      //                 handleChange(field.name, e.target.files[0])
      //               }
      //               className="file-input"
      //               style={{ display: "none" }}
      //             />
      //             <label htmlFor={field.name} className="custom-file-label">
      //               <div
      //                 style={{
      //                   display: "flex",
      //                   flexDirection: "column",
      //                   alignItems: "center",
      //                   justifyContent: "center",
      //                 }}
      //               >
      //                 <img src={uploadIcon} />
      //                 {fileNames[field.name] ||
      //                   "Drag and drop a file or click to upload"}
      //               </div>
      //             </label>
      //           </div>
      //         </div>
      //         {validationErrors[field.name] && (
      //           <div className="invalid-feedback">
      //             {validationErrors[field.name]}
      //           </div>
      //         )}
      //         {formData[field.name] ? (
      //           <div style={{ marginTop: "10px" }}>
      //             Image uploaded successfully
      //           </div>
      //         ) : null}
      //       </div>
      //     </>
      //   );

      case "button":
        return (
          <div className=" mt-1 mb-2">
            <label>{""}</label>
            <div className="downloadiconwrapper " onClick={buttonOnclick}>
              <label>{field.label}</label>
            </div>
          </div>
        );
      // case "date":
      //   const openDatePicker = (fieldName) => {
      //     if (datePickerRefs.current[fieldName]) {
      //       datePickerRefs.current[fieldName].setFocus();
      //     }
      //   };

      //   return (
      //     <div key={field?.name} className="mt-2 mb-2">
      //       <label>
      //         {field.label}{" "}
      //         {field.required && <span className="required-asterisk">*</span>}
      //       </label>
      //       <div className="input-group">
      //         <DatePicker
      //           ref={(ref) => (datePickerRefs.current[field.name] = ref)}
      //           placeholderText="DD/MM/YYYY"
      //           disabled={field?.disabled ? true : false}
      //           selected={
      //             formData[field?.name] ? new Date(formData[field.name]) : null
      //           }
      //           onChange={(date) => handleChange(field.name, date, "date")}
      //           // dateFormat="yyyy-MM-dd"
      //           dateFormat=" dd/MM/YYYY"
      //           className={`form-control ${
      //             validationErrors[field.name] && "is-invalid"
      //           }`}
      //         />
      //         <span
      //           className="input-group-text"
      //           onClick={() => openDatePicker(field.name)}
      //           style={{ cursor: "pointer" }}
      //         >
      //           <FaCalendarAlt />
      //         </span>
      //       </div>
      //       {validationErrors[field.name] && (
      //         <div className="invalid-feedback">
      //           {validationErrors[field.name]}
      //         </div>
      //       )}
      //     </div>
      //   );
      case "date":
        const openDatePicker = (fieldName) => {
          if (datePickerRefs.current[fieldName]) {
            datePickerRefs.current[fieldName].setFocus();
          }
        };
      
        return (
          <div key={field?.name} className="mt-2 mb-2">
            <label>
              {field.label}{" "}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={(ref) => (datePickerRefs.current[field.name] = ref)}
                placeholderText={field.showMonthYearPicker ? "MM/YYYY" : "DD/MM/YYYY"}
                disabled={field?.disabled ? true : false}
                
                // Handling month and year selection
                selected={
                  formData[field?.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "date")}
      
                dateFormat={field.showMonthYearPicker ? "MM/yyyy" : "dd/MM/yyyy"}
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
                minDate={field?.minDate}
                maxDate={field?.maxDate}
      
                // Enable month/year picker only
                showMonthYearPicker={field.showMonthYearPicker}
      
                // Hide dropdowns for month/year when month-year picker is active
                showMonthDropdown={!field.showMonthYearPicker}
                showYearDropdown={!field.showMonthYearPicker}
      
                dropdownMode="select"
              />
              <span
                className="input-group-text"
                onClick={() => openDatePicker(field.name)}
                style={{ cursor: "pointer" }}
              >
                <FaCalendarAlt />
              </span>
            </div>
            {validationErrors[field.name] && (
              <div className="error-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      
      // case "date":
      //   const openDatePicker = (fieldName) => {
      //     if (datePickerRefs.current[fieldName]) {
      //       datePickerRefs.current[fieldName].setFocus();
      //     }
      //   };
      
      //   return (
      //     <div key={field?.name} className="mt-2 mb-2">
      //       <label>
      //         {field.label}{" "}
      //         {field.required && <span className="required-asterisk">*</span>}
      //       </label>
      //       <div className="input-group">
      //         <DatePicker
      //           ref={(ref) => (datePickerRefs.current[field.name] = ref)}
      //           placeholderText="DD/MM/YYYY"
      //           disabled={field?.disabled ? true : false}
      //           maxDate={field?.maxDate}
      //           selected={
      //             formData[field?.name] ? new Date(formData[field.name]) : null
      //           }
      //           onChange={(date) => handleChange(field.name, date, "date")}
      //           dateFormat="dd/MM/yyyy" // Correct format with lowercase
      //           className={`form-control ${
      //             validationErrors[field.name] ? "is-invalid" : ""
      //           }`}
      //         />
      //         <span
      //           className="input-group-text"
      //           onClick={() => openDatePicker(field.name)}
      //           style={{ cursor: "pointer" }}
      //         >
      //           <FaCalendarAlt />
      //         </span>
      //       </div>
      //       {validationErrors[field.name] && (
      //             <div className="error-feedback">
      //               {validationErrors[field.name]}
      //             </div>
      //           )}
      //     </div>
      //   );
    
        case "datetime":
        return (
          <div key={field.name} className="form-group mt-2 mb-2">
            <label>
              {field.label}
              {field.required && <span className="required-asterisk">*</span>}
            </label>
            <div className="input-group">
              <DatePicker
                ref={datePickerRefs}
                disabled={field?.disabled ? true : false}
                selected={
                  formData[field.name] ? new Date(formData[field.name]) : null
                }
                onChange={(date) => handleChange(field.name, date, "datetime")}
                showTimeSelect
                dateFormat="Pp"
                maxDate={field.maxDate}
                minDate={field.minDate}
                inputProps={{ readOnly: true }}   
                className={`form-control ${
                  validationErrors[field.name] && "is-invalid"
                }`}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  onClick={() => datePickerRefs.current.setFocus()}
                >
                  <FaCalendarAlt />
                </span>
              </div>
            </div>
            {validationErrors[field.name] && (
              <div className="invalid-feedback">
                {validationErrors[field.name]}
              </div>
            )}
          </div>
        );
      case "toggle":
        return (
          <div
            key={field?.name}
            className={`${additionalClass} mt-3 mb-3 togglecontainer`}
          >
            <Switch
              checked={formData[field?.name] || false}
              onChange={(checked) =>
                handleChange(field?.name, checked, "toggle")
              }
              onColor="#7BD755"
              onHandleColor="#7BD755"
              handleDiameter={30}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              height={20}
              width={48}
              className="react-switch"
              id="material-switch"
              disabled={field?.disabled ? true : false}
            />
            <label className="mt-3 mb-3">{field.label}</label>
            {validationErrors[field?.name] && (
              <div className="invalid-feedback">
                {validationErrors[field?.name]}
              </div>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <ToastContainer />
      {/* <div className="dynamicform-parent"> */}
      {formConfig?.map((field) => (
        <div key={field?.name} className={`${field.gridClass}`}>
          {(showParentDesignation || field?.isVisible !== false) &&
            renderField(field)}
          {/* {renderField(field)} */}
        </div>
      ))}
      {/* </div> */}
    </div>
  );
};

export default AddIssueDynemicForm;
